export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '星链专线物流开票机',
  copyright: '版权所有：临沂星链网络科技有限公司',
  systemname: '星链专线物流开票机',
  systemsubname: '星链',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://localhost:8080/', // http://localhost:9001/
    dev: 'https://56tms.xinglianxinglian.com/prod-api/',
    pro: 'https://56tms.xinglianxinglian.com/prod-api/'
  },
  fileUrl: {
    dev: 'https://file.xinglianxinglian.com/', // http://localhost:9001/
    pro: 'https://file.xinglianxinglian.com/'
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'guide',
  // homeName: 'home',
  homeName2: 'home2',
  offlineHomeName: 'offlineHome',
  isCustom:0,
  version: 1,
  /**
   * @description 需要加载的插件
   */
  plugin: {
    // 'error-store': {
    //   showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
    //   developmentOff: false // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    // }
  }
}
